import { render, staticRenderFns } from "./TasksIconBadge.vue?vue&type=template&id=5a482332"
import script from "./TasksIconBadge.vue?vue&type=script&lang=js"
export * from "./TasksIconBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports